const arcSystem = {
	elements: {
		$body: $(document.body),
		$arcSystemButton: $('.js-arc-system-button'),
		$arcSystemOverlay: $('.js-arc-system-overlay'),
		$arcSystemOverlayButton: $('.js-arc-system-overlay-button'),
		$youtubePlayer: $('#youtube_player'),
	},

	modifiers:{
		bodyLocked: 'body--locked',
	},

	init() {
		this.initEvents()
	},

	initEvents() {
		this.elements.$arcSystemButton.on('click', this.toogleVideoOverlay.bind(this))
		this.elements.$arcSystemOverlayButton.on('click', this.toogleVideoOverlay.bind(this))
	},

	toogleVideoOverlay(){
		const isInert = this.elements.$arcSystemOverlay.prop('inert')

		this.elements.$arcSystemOverlay.prop('inert', !isInert)
		this.elements.$body.toggleClass(this.modifiers.bodyLocked)

		const func = isInert ? 'playVideo' : 'stopVideo'
		this.elements.$youtubePlayer[0].contentWindow.postMessage(`{"event":"command","func":"${func}","args":""}`, '*');
	},
}

arcSystem.init();
